import React ,{Component } from 'react';
import CertReqList from '../views/certreqlist';
import { certrequestActions } from "../../actions";
import { connect } from 'react-redux';

class CertReqListContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
        this.getData = this.getData.bind(this);
        this.archiveData = this.archiveData.bind(this);
        this.deleteData= this.deleteData.bind(this);
    }
    componentDidMount(){
        const {dispatch} = this.props;
        dispatch(certrequestActions.gets(1,10,'','',''));
    }

    getData(page,perPage,sortField,sortOrder,filter)
    {
        const {dispatch} = this.props;
        dispatch(certrequestActions.gets(page,perPage,sortField,sortOrder,filter));
    }

    deleteData(id)
    {
        const {dispatch} = this.props;
        var result=window.confirm('آیا مطمئن هستید ؟');
        if(result)
        {
            
            dispatch(certrequestActions.deletecertificate(id,certrequestActions.gets(1,10,'','','')));
        }
    }

    archiveData(id)
    {
        const {dispatch} = this.props;
        var result=window.confirm('آیا مطمئن هستید ؟');
        if(result)
        {
            
            dispatch(certrequestActions.archivecertificate(id,certrequestActions.gets(1,10,'','','')));
        }
    }
    
    render() { 

        const {list}=this.props;
       // console.log('LIST',list);


        return ( 
           <CertReqList remoteDataHandler={this.getData} deleteHandler={this.deleteData} archiveHandler={this.archiveData} list={list}></CertReqList>
         );
    }
}

function mapStateToProps(state) {
    const { objs } = state;
    const { items } = objs;
    //const { queryable } = items;
    return {
        list:items   
        
    };
} 

export default connect(mapStateToProps)(CertReqListContainer);